// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --bw-text: #13231D;
  --bw-text-secondary: rgba(19, 35, 29, 0.68);
  --bw-text-tertiary: rgba(19, 35, 29, 0.46);
  --bw-primary: #82B194;
  --base-container: 1280px;
  --gutter-desktop: 40px;
  --gutter-tablet: 28px;
  --gutter-mobile: 20px;
  --border-soft: rgba(19, 35, 29, 0.08);
  --border-mid: rgba(19, 35, 29, 0.22);
  --radius-card: 32px;
  --radius-card-sm: 24px;
  --radius-button: 20px;
  --radius-button-header: 18px;
  --shadow-soft: 0 18px 48px rgba(18, 34, 29, 0.04);
}

.EditPatientPage_patient-profile__Ude0e {
  width: 100%;
  font-family: "Sora", system-ui, -apple-system, "Segoe UI", Roboto, Arial, sans-serif;
}
.EditPatientPage_patient-profile__title-block__2KQQE {
  display: flex;
  align-items: center;
  gap: 16px;
  margin: 10px 0 22px;
}
@media (max-width: 820px) {
  .EditPatientPage_patient-profile__title-block__2KQQE {
    gap: 12px;
    margin-bottom: 16px;
  }
}
.EditPatientPage_patient-profile__hero-mark__GUluk span {
  width: 32px;
  height: 32px;
  background: rgba(130, 177, 148, 0.1);
  color: #82B194;
  border-radius: 10px;
  display: grid;
  place-items: center;
  font-size: 18px;
  font-weight: 800;
}
@media (max-width: 820px) {
  .EditPatientPage_patient-profile__hero-mark__GUluk {
    width: 40px;
    height: 40px;
    flex: 0 0 40px;
  }
  .EditPatientPage_patient-profile__hero-mark__GUluk span {
    font-size: 20px;
  }
}
.EditPatientPage_patient-profile__main-title__FdjpB {
  margin: 0;
  font-size: 28px;
  line-height: 0.96;
  letter-spacing: -0.055em;
  font-weight: 800;
  color: #13231D;
  flex: 1 1;
}
.EditPatientPage_patient-profile__edit-trigger__V5Zs3 {
  appearance: none;
  background: #82B194;
  color: #fff;
  border: none;
  padding: 10px 20px;
  border-radius: 14px;
  font-weight: 800;
  cursor: pointer;
  font-size: 13px;
  transition: background 0.2s ease;
}
.EditPatientPage_patient-profile__edit-trigger__V5Zs3:hover {
  background: #739F84;
}
@media (max-width: 820px) {
  .EditPatientPage_patient-profile__edit-trigger__V5Zs3 {
    width: 100%;
    padding: 14px 20px;
    font-size: 14px;
  }
}
.EditPatientPage_patient-profile__layout__Yzu\\+h {
  display: grid;
  grid-template-columns: minmax(0, 1.6fr) 300px;
  gap: 28px;
  align-items: start;
}
@media (max-width: 1180px) {
  .EditPatientPage_patient-profile__layout__Yzu\\+h {
    grid-template-columns: 1fr;
  }
}
.EditPatientPage_patient-profile__content-column__5KrNt {
  min-width: 0;
  position: relative;
}
.EditPatientPage_patient-profile__card-stack__yLhqO {
  display: grid;
  gap: 24px;
}
.EditPatientPage_patient-profile__aside__D3Hm1 {
  position: sticky;
  top: 96px;
}
@media (max-width: 1180px) {
  .EditPatientPage_patient-profile__aside__D3Hm1 {
    position: static;
    grid-row: 1;
  }
}
.EditPatientPage_patient-profile__actions__vD-iy {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 12px;
  margin: 8px 0;
}

.EditPatientPage_content-card__YPMxc {
  background: #F7F5F1;
  border: 1px solid rgba(16, 25, 21, 0.05);
  border-radius: 28px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.03);
  padding: 28px 28px 32px;
  min-width: 0;
  width: 100%;
}
@media (max-width: 820px) {
  .EditPatientPage_content-card__YPMxc {
    padding: 20px 16px 24px;
    border-radius: 20px;
  }
}
.EditPatientPage_content-card__head__4nXBC {
  display: grid;
  gap: 4px;
  margin-bottom: 28px;
}
.EditPatientPage_content-card__name__EzegJ {
  margin: 0;
  font-size: 23px;
  font-weight: 800;
  letter-spacing: -0.04em;
  color: #13231D;
}
.EditPatientPage_content-card__email__Z6PXR {
  margin: 0;
  font-size: 13px;
  color: rgba(19, 35, 29, 0.68);
}
.EditPatientPage_content-card__divider__0IPxF {
  height: 1px;
  background: rgba(16, 25, 21, 0.06);
  margin: 0 0 28px;
}
.EditPatientPage_content-card__grid-2__ehee4 {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 24px;
}
@media (max-width: 820px) {
  .EditPatientPage_content-card__grid-2__ehee4 {
    grid-template-columns: 1fr;
  }
}
.EditPatientPage_content-card__grid-address__TJSQ8 {
  display: grid;
  grid-template-columns: minmax(0, 1.4fr) minmax(200px, 0.6fr);
  gap: 24px;
}
@media (max-width: 820px) {
  .EditPatientPage_content-card__grid-address__TJSQ8 {
    grid-template-columns: 1fr;
  }
}
.EditPatientPage_content-card__grid-1__IU7Qa {
  margin-top: 24px;
  max-width: 48%;
}
@media (max-width: 820px) {
  .EditPatientPage_content-card__grid-1__IU7Qa {
    max-width: 100%;
  }
}
.EditPatientPage_content-card__section-title__cDARv {
  margin: 0 0 26px;
  font-size: 16px;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: -0.02em;
}
.EditPatientPage_content-card__view-text__IKLNG {
  background: #fff;
  border: 1px solid rgba(21, 36, 30, 0.1);
  border-radius: 16px;
  padding: 18px;
  min-height: 150px;
  color: rgba(19, 35, 29, 0.68);
  line-height: 1.65;
  min-width: 0;
  width: 100%;
  overflow-x: hidden;
  overflow-wrap: break-word;
  word-wrap: break-word;
  word-break: normal;
}
@media (max-width: 820px) {
  .EditPatientPage_content-card__view-text__IKLNG {
    padding: 14px;
    min-height: 120px;
  }
}
.EditPatientPage_content-card__view-text__IKLNG * {
  max-width: 100%;
}

.EditPatientPage_field__4h8No {
  display: grid;
  gap: 10px;
}
.EditPatientPage_field__label__XVLz3 {
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: #6E897C;
}
.EditPatientPage_field__input__gQZkK {
  min-height: 50px;
  background: #FFFFFF;
  border: 1px solid rgba(21, 36, 30, 0.08);
  border-radius: 16px;
  padding: 0 16px;
  display: flex;
  align-items: center;
  font-size: 14px;
  color: #13231D;
  font-weight: 600;
}
.EditPatientPage_field__4h8No .MuiInputBase-root {
  min-height: 50px !important;
  background: #fff !important;
  border-radius: 16px !important;
}
.EditPatientPage_field__4h8No .MuiInputBase-root .EditPatientPage_MuiOutlinedInput-notchedOutline__no1lo {
  border-color: rgba(21, 36, 30, 0.08) !important;
}

.EditPatientPage_side-photo__UcIox {
  display: grid;
  gap: 16px;
}
@media (max-width: 1180px) {
  .EditPatientPage_side-photo__UcIox {
    justify-items: center;
    text-align: center;
    margin-bottom: 16px;
  }
}
.EditPatientPage_side-photo__frame__4I7Ag {
  width: 176px;
  height: 176px;
  border-radius: 30px;
  padding: 6px;
  background: #FFFFFF;
  box-shadow: 0 8px 20px rgba(18, 34, 28, 0.06);
  position: relative;
}
.EditPatientPage_side-photo__img-container__15yjS {
  width: 100%;
  height: 100%;
  border-radius: 24px;
  overflow: hidden;
  background: #F1EEE8;
}
.EditPatientPage_side-photo__img-container__15yjS img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.EditPatientPage_side-photo__edit-btn__w0R8X {
  position: absolute;
  right: -2px;
  bottom: -2px;
  width: 34px;
  height: 34px;
  border-radius: 12px;
  background: #82B194;
  color: #fff;
  border: none;
  display: grid;
  place-items: center;
  box-shadow: 0 6px 14px rgba(18, 34, 28, 0.12);
  cursor: pointer;
  font-weight: 800;
}
.EditPatientPage_side-photo__meta__a6AEJ h3 {
  margin: 0 0 6px;
  font-size: 17px;
  font-weight: 800;
}
.EditPatientPage_side-photo__meta__a6AEJ p {
  margin: 0;
  font-size: 12px;
  color: rgba(19, 35, 29, 0.68);
  line-height: 1.55;
}

.EditPatientPage_save-bar__GWv4M {
  position: sticky;
  bottom: 20px;
  z-index: 1000;
  width: 100%;
}
.EditPatientPage_save-bar__pill__ADoCs {
  min-height: 74px;
  border-radius: 24px;
  background: #F7F5F1;
  border: 1px solid rgba(16, 25, 21, 0.05);
  box-shadow: 0 10px 18px rgba(18, 34, 28, 0.1);
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  margin-top: 20px;
}
@media (max-width: 820px) {
  .EditPatientPage_save-bar__pill__ADoCs {
    flex-direction: column;
    gap: 12px;
    height: auto;
    width: 100%;
  }
}
.EditPatientPage_save-bar__state__aLJlg {
  display: flex;
  align-items: flex-start;
  gap: 10px;
}
.EditPatientPage_save-bar__dot__vfhP- {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #82B194;
  margin-top: 6px;
}
.EditPatientPage_save-bar__dot--saved__Ybnuu {
  background-color: #76A886;
}
.EditPatientPage_save-bar__copy__np5mk {
  font-size: 13px;
  font-weight: 800;
  color: #13231D;
}
.EditPatientPage_save-bar__sub__bLJMO {
  font-size: 12px;
  color: rgba(19, 35, 29, 0.68);
}
.EditPatientPage_save-bar__actions__6muDw {
  display: flex;
  gap: 10px;
}
@media (max-width: 820px) {
  .EditPatientPage_save-bar__actions__6muDw {
    width: 100%;
  }
}

.EditPatientPage_save-cta__U4skG {
  min-width: 148px;
  min-height: 42px;
  border-radius: 14px;
  background: #82B194;
  color: #fff;
  border: none;
  font-weight: 800;
  cursor: pointer;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  font-weight: 800;
  white-space: nowrap;
}
@media (max-width: 820px) {
  .EditPatientPage_save-cta__U4skG {
    flex: 1 1;
  }
}

.EditPatientPage_btn-secondary__V7nYN {
  min-height: 40px;
  padding: 0 18px;
  border-radius: 14px;
  background: transparent;
  border: 1px solid rgba(130, 177, 148, 0.4);
  color: #13231D;
  font-weight: 800;
  cursor: pointer;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  font-weight: 800;
  white-space: nowrap;
}
@media (max-width: 820px) {
  .EditPatientPage_btn-secondary__V7nYN {
    flex: 1 1;
  }
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/_variables.scss","webpack://./src/pages/EditPatientPage/EditPatientPage.module.scss"],"names":[],"mappings":"AAyIA;EACI,kBAAA;EACA,2CAAA;EACA,0CAAA;EACA,qBAAA;EAEA,wBAAA;EACA,sBAAA;EACA,qBAAA;EACA,qBAAA;EAGA,qCAAA;EACA,oCAAA;EAEA,mBAAA;EACA,sBAAA;EACA,qBAAA;EACA,4BAAA;EAEA,iDAAA;AC7IJ;;AAdI;EACI,WAAA;EACA,oFDEI;ACeZ;AAfQ;EACI,aAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;AAiBZ;AAfY;EANJ;IAOQ,SAAA;IACA,mBAAA;EAkBd;AACF;AALY;EACI,WAAA;EACA,YAAA;EACA,oCAAA;EACA,cAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;AAOhB;AAJY;EAtBJ;IAuBQ,WAAA;IACA,YAAA;IACA,cAAA;EAOd;EALc;IACI,eAAA;EAOlB;AACF;AAHQ;EACI,SAAA;EACA,eAAA;EACA,iBAAA;EACA,wBAAA;EACA,gBAAA;EACA,cDjCW;ECkCX,SAAA;AAKZ;AAFQ;EACI,gBAAA;EACA,mBDpDW;ECqDX,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,eAAA;EACA,gCAAA;AAIZ;AAFY;EACI,mBD9DO;ACkEvB;AADY;EAhBJ;IAiBQ,WAAA;IACA,kBAAA;IACA,eAAA;EAId;AACF;AADQ;EACI,aAAA;EACA,6CAAA;EACA,SAAA;EACA,kBAAA;AAGZ;AADY;EANJ;IAOQ,0BAAA;EAId;AACF;AADQ;EACI,YAAA;EACA,kBAAA;AAGZ;AAAQ;EACI,aAAA;EACA,SAAA;AAEZ;AACQ;EACI,gBAAA;EACA,SAAA;AACZ;AACY;EAJJ;IAKQ,gBAAA;IACA,WAAA;EAEd;AACF;AACQ;EACI,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,SAAA;EACA,aAAA;AACZ;;AAGI;EACI,mBAAA;EACA,wCAAA;EACA,mBAAA;EACA,2CD9DM;EC+DN,uBAAA;EACA,YAAA;EACA,WAAA;AAAR;AAEQ;EATJ;IAUQ,uBAAA;IACA,mBAAA;EACV;AACF;AACQ;EACI,aAAA;EACA,QAAA;EACA,mBAAA;AACZ;AAEQ;EACI,SAAA;EACA,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,cD7HW;AC6HvB;AAGQ;EACI,SAAA;EACA,eAAA;EACA,6BDjIW;ACgIvB;AAIQ;EACI,WAAA;EACA,kCAAA;EACA,gBAAA;AAFZ;AAKQ;EACI,aAAA;EACA,8BAAA;EACA,SAAA;AAHZ;AAKY;EALJ;IAMQ,0BAAA;EAFd;AACF;AAKQ;EACI,aAAA;EACA,4DAAA;EACA,SAAA;AAHZ;AAKY;EALJ;IAMQ,0BAAA;EAFd;AACF;AAKQ;EACI,gBAAA;EACA,cAAA;AAHZ;AAKY;EAJJ;IAKQ,eAAA;EAFd;AACF;AAKQ;EACI,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,uBAAA;AAHZ;AAMQ;EACI,gBAAA;EACA,uCAAA;EACA,mBAAA;EACA,aAAA;EACA,iBAAA;EACA,6BDrLW;ECsLX,iBAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,yBAAA;EACA,qBAAA;EACA,kBAAA;AAJZ;AAMY;EAfJ;IAgBQ,aAAA;IACA,iBAAA;EAHd;AACF;AAKY;EACI,eAAA;AAHhB;;AASI;EACI,aAAA;EACA,SAAA;AANR;AAQQ;EACI,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;EACA,cAAA;AANZ;AASQ;EACI,gBAAA;EACA,mBAAA;EACA,wCAAA;EACA,mBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,cDjOW;ECkOX,gBAAA;AAPZ;AAWQ;EACI,2BAAA;EACA,2BAAA;EACA,8BAAA;AATZ;AAWY;EACI,+CAAA;AAThB;;AAcI;EACI,aAAA;EACA,SAAA;AAXR;AAaQ;EAJJ;IAKQ,qBAAA;IACA,kBAAA;IACA,mBAAA;EAVV;AACF;AAYQ;EACI,YAAA;EACA,aAAA;EACA,mBAAA;EACA,YAAA;EACA,mBAAA;EACA,6CAAA;EACA,kBAAA;AAVZ;AAaQ;EACI,WAAA;EACA,YAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;AAXZ;AAaY;EACI,WAAA;EACA,YAAA;EACA,iBAAA;AAXhB;AAeQ;EACI,kBAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,mBDvSW;ECwSX,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,6CAAA;EACA,eAAA;EACA,gBAAA;AAbZ;AAiBY;EACI,eAAA;EACA,eAAA;EACA,gBAAA;AAfhB;AAkBY;EACI,SAAA;EACA,eAAA;EACA,6BD5SO;EC6SP,iBAAA;AAhBhB;;AAqBI;EACI,gBAAA;EACA,YAAA;EACA,aAAA;EACA,WAAA;AAlBR;AAoBQ;EACI,gBAAA;EACA,mBAAA;EACA,mBAAA;EACA,wCAAA;EACA,6CAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;EACA,gBAAA;AAlBZ;AAoBY;EAZJ;IAaQ,sBAAA;IACA,SAAA;IACA,YAAA;IACA,WAAA;EAjBd;AACF;AAoBQ;EACI,aAAA;EACA,uBAAA;EACA,SAAA;AAlBZ;AAqBQ;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBDrWW;ECsWX,eAAA;AAnBZ;AAqBY;EACI,yBAAA;AAnBhB;AAuBQ;EACI,eAAA;EACA,gBAAA;EACA,cDnWW;AC8UvB;AAwBQ;EACI,eAAA;EACA,6BDtWW;ACgVvB;AAyBQ;EACI,aAAA;EACA,SAAA;AAvBZ;AAyBY;EAJJ;IAKQ,WAAA;EAtBd;AACF;;AA0BI;EACI,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,mBDtYe;ECuYf,WAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;AAvBR;AAyBQ;EAfJ;IAgBQ,SAAA;EAtBV;AACF;;AAyBI;EACI,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,uBAAA;EACA,0CAAA;EACA,cD/Ye;ECgZf,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;AAtBR;AAwBQ;EAfJ;IAgBQ,SAAA;EArBV;AACF","sourcesContent":["\n// =============================================================================\n// BODHIWELL DESIGN TOKENS\n// =============================================================================\n\n// FONTS\n$font-main: \"Sora\", system-ui, -apple-system, \"Segoe UI\", Roboto, Arial, sans-serif;\n$font-accent: $font-main;\n\n\n// Brand Colors\n$color-primary:        #82B194; // CTA principal, estados activos y acentos del sistema.\n$color-primary-hover:  #739F84;\n$color-primary-active: #678F77;\n$color-gold:           #D6A640;  // Acento complementario para journeys, hitos y estados destacados dentro del dashboard.\n$color-gold-soft:      rgba(214, 166, 64, 0.10);\n\n// Backgrounds & Surfaces\n$color-bg:             #EFF0EC; // Fondo general del sistema y de ejemplos.\n$color-surface:        #F7F5F1; // Superficie oficial para cards, modales y contenedores principales del sistema.\n$color-surface-soft:   #F8F6F2; // Variante suave para interiores, previews, campos y superficies secundarias.\n$color-border:         rgba(16, 25, 21, 0.08); \n\n// Text Colors\n$text-main:            #13231D; // Titulares, labels y acciones principales. Color principal para títulos, cuerpo y acciones prioritarias. \n$text-muted:           #5F726B;\n$text-secondary:       rgba(19,35,29,.68); // Textos de apoyo, descripciones, subtítulos y metadata.\n$text-tertiary:        rgba(19,35,29,.46);  // Footer, placeholders y elementos de menor jerarquía visual.\n\n// Status Colors\n$color-error:          #C95C5C; // Mensajes de validación, borde error y helper error.\n\n\n// Font Sizes\n$font-size-h1:      64px; \n$font-size-h2:      48px; \n$font-size-h3:      24px; \n$font-size-title-mobile: 32px; \n$font-size-body:    16px; \n$font-size-small:   14px; \n$font-size-caption: 13px; \n\n$font-size-section-titles: $font-size-h2; \n$font-size-section-subtitles: $font-size-h3;\n$font-size-section-descripcion: $font-size-body;\n\n$radius-nav:    12px;  // Navegación del manual, tabs suaves y acciones de baja jerarquía.\n$radius-sm:     14px;  // Botones de soporte, badges rectangulares y accesos rápidos.\n$radius-md:     16px;  // Botones principales, inputs, CTA sobre imagen y controles activos.\n$radius-lg:     18px;  // Cards internas, previews, notas y paneles secundarios.\n$radius-xl:     24px;  // Cards principales del manual, modales y contenedores base del sistema.\n$radius-pill:   999px; // Tags de dimensión, chips y elementos totalmente redondeados.\n\n$border-radius: $radius-md;\n$btn-radius:    $radius-pill;\n\n// --- 5. SPACING SCALE ---\n$space-4:  4px;\n$space-8:  8px;\n$space-12: 12px;\n$space-16: 16px;\n$space-24: 24px;\n$space-32: 32px;\n$space-48: 48px;\n\n// --- 6. SHADOWS ---\n$shadow-card: 0 10px 30px rgba(0, 0, 0, 0.03); \n\n$header-height:       64px;\n$sidebar-width-open:  240px;\n$sidebar-width-closed: 80px;\n$submenu-panel-width: 280px;\n\n$transition-speed:    0.3s;\n\n$breakpoint-sm:       576px;\n$breakpoint-md:       768px;\n$breakpoint-lg:       992px;\n$breakpoint-desktop:  1024px;\n\n$base-container:1280px;\n$gutter-desktop:40px;\n$gutter-tablet:28px;\n$gutter-mobile:20px;\n\n$border-soft:rgba(19,35,29,.08);\n$border-mid:rgba(19,35,29,.22);\n\n$radius-card:32px;\n$radius-card-sm:24px;\n$radius-button:20px;\n$radius-button-header:18px;\n\n$shadow-soft:0 18px 48px rgba(18,34,29,.04);\n\n$sidebar-bg:           $color-surface;\n$sidebar-submenu-bg:   #ffffff;\n$sidebar-text-color:   $text-main;\n$sidebar-active-bg:    rgba($color-primary, 0.1);\n$sidebar-active-text:  $color-primary;\n\n\n// Mixins para Tipografía\n@mixin h1 {\n    font-size: 64px;\n    line-height: 1.0;\n    font-weight: 700;\n    letter-spacing: -0.045em;\n}\n\n@mixin h2 {\n    font-size: 48px;\n    line-height: 1.04;\n    font-weight: 800;\n    letter-spacing: -0.035em;\n}\n\n@mixin h3 {\n    font-size: 24px;\n    line-height: 1.28;\n    font-weight: 600;\n    letter-spacing: -0.015em;\n}\n\n@mixin body-text {\n    font-size: 16px;\n    line-height: 1.65;\n    font-weight: 400;\n}\n\n@mixin small-text {\n    font-size: 14px;\n    line-height: 1.5;\n    font-weight: 400;\n}\n\n\n:root {\n    --bw-text: #{$text-main};\n    --bw-text-secondary: #{$text-secondary};\n    --bw-text-tertiary: #{$text-tertiary};\n    --bw-primary: #{$color-primary};\n\n    --base-container: #{$base-container};\n    --gutter-desktop: #{$gutter-desktop};\n    --gutter-tablet: #{$gutter-tablet};\n    --gutter-mobile: #{$gutter-mobile};\n\n\n    --border-soft: #{$border-soft};\n    --border-mid: #{$border-mid};\n\n    --radius-card: #{$radius-card};\n    --radius-card-sm: #{$radius-card-sm};\n    --radius-button: #{$radius-button};\n    --radius-button-header: #{$radius-button-header};\n\n    --shadow-soft: #{$shadow-soft};\n\n}\n\n//Notes\n//El color oficial de card queda formalizado como --bw-card-surface con valor #F7F5F1. \n//Su variante complementaria --bw-card-surface-soft usa #F8F6F2 para superficies internas, previews y contenedores suaves.","    @import '../../assets/styles/variables';\n\n    .patient-profile {\n        width: 100%;\n        font-family: $font-main;\n\n        &__title-block {\n            display: flex;\n            align-items: center;\n            gap: 16px;\n            margin: 10px 0 22px;\n\n            @media (max-width: 820px) {\n                gap: 12px;\n                margin-bottom: 16px;\n            }\n        }\n\n        &__hero-mark {\n            // width: 48px;\n            // height: 48px;\n            // border-radius: 50%;\n            // background: #F7F5F1;\n            // display: grid;\n            // place-items: center;\n            // color: #76A886;\n            // flex: 0 0 48px;\n\n            span {\n                width: 32px;\n                height: 32px;\n                background: rgba(130, 177, 148, 0.1);\n                color: #82B194;\n                border-radius: 10px;\n                display: grid;\n                place-items: center;\n                font-size: 18px;\n                font-weight: 800;\n            }\n\n            @media (max-width: 820px) {\n                width: 40px;\n                height: 40px;\n                flex: 0 0 40px;\n\n                span {\n                    font-size: 20px;\n                }\n            }\n        }\n\n        &__main-title {\n            margin: 0;\n            font-size: 28px;\n            line-height: .96;\n            letter-spacing: -.055em;\n            font-weight: 800;\n            color: $text-main;\n            flex: 1;\n        }\n\n        &__edit-trigger {\n            appearance: none;\n            background: $color-primary;\n            color: #fff;\n            border: none;\n            padding: 10px 20px;\n            border-radius: 14px;\n            font-weight: 800;\n            cursor: pointer;\n            font-size: 13px;\n            transition: background 0.2s ease;\n\n            &:hover {\n                background: $color-primary-hover;\n            }\n\n            @media (max-width: 820px) {\n                width: 100%;\n                padding: 14px 20px;\n                font-size: 14px;\n            }\n        }\n\n        &__layout {\n            display: grid;\n            grid-template-columns: minmax(0, 1.6fr) 300px;\n            gap: 28px;\n            align-items: start;\n\n            @media (max-width: 1180px) {\n                grid-template-columns: 1fr;\n            }\n        }\n\n        &__content-column {\n            min-width: 0;\n            position: relative;\n        }\n\n        &__card-stack {\n            display: grid;\n            gap: 24px;\n        }\n\n        &__aside {\n            position: sticky;\n            top: 96px;\n\n            @media (max-width: 1180px) {\n                position: static;\n                grid-row: 1;\n            }\n        }\n\n        &__actions {\n            display: flex;\n            align-items: center;\n            justify-content: flex-start;\n            gap: 12px;\n            margin: 8px 0;\n        }\n    }\n\n    .content-card {\n        background: #F7F5F1;\n        border: 1px solid rgba(16, 25, 21, 0.05);\n        border-radius: 28px;\n        box-shadow: $shadow-card;\n        padding: 28px 28px 32px;\n        min-width: 0;\n        width: 100%;\n\n        @media (max-width: 820px) {\n            padding: 20px 16px 24px;\n            border-radius: 20px;\n        }\n\n        &__head {\n            display: grid;\n            gap: 4px;\n            margin-bottom: 28px;\n        }\n\n        &__name {\n            margin: 0;\n            font-size: 23px;\n            font-weight: 800;\n            letter-spacing: -.04em;\n            color: $text-main;\n        }\n\n        &__email {\n            margin: 0;\n            font-size: 13px;\n            color: $text-secondary;\n        }\n\n        &__divider {\n            height: 1px;\n            background: rgba(16, 25, 21, 0.06);\n            margin: 0 0 28px;\n        }\n\n        &__grid-2 {\n            display: grid;\n            grid-template-columns: 1fr 1fr;\n            gap: 24px;\n\n            @media (max-width: 820px) {\n                grid-template-columns: 1fr;\n            }\n        }\n\n        &__grid-address {\n            display: grid;\n            grid-template-columns: minmax(0, 1.4fr) minmax(200px, 0.6fr);\n            gap: 24px;\n\n            @media (max-width: 820px) {\n                grid-template-columns: 1fr;\n            }\n        }\n\n        &__grid-1 {\n            margin-top: 24px;\n            max-width: 48%;\n\n            @media (max-width: 820px) {\n                max-width: 100%;\n            }\n        }\n\n        &__section-title {\n            margin: 0 0 26px;\n            font-size: 16px;\n            font-weight: 800;\n            text-transform: uppercase;\n            letter-spacing: -.02em;\n        }\n\n        &__view-text {\n            background: #fff;\n            border: 1px solid rgba(21, 36, 30, 0.1);\n            border-radius: 16px;\n            padding: 18px;\n            min-height: 150px;\n            color: $text-secondary;\n            line-height: 1.65;\n            min-width: 0;\n            width: 100%;\n            overflow-x: hidden;\n            overflow-wrap: break-word;\n            word-wrap: break-word;\n            word-break: normal;\n\n            @media (max-width: 820px) {\n                padding: 14px;\n                min-height: 120px;\n            }\n\n            * {\n                max-width: 100%;\n            }\n        }\n\n    }\n\n    .field {\n        display: grid;\n        gap: 10px;\n\n        &__label {\n            font-size: 11px;\n            font-weight: 800;\n            letter-spacing: .14em;\n            text-transform: uppercase;\n            color: #6E897C;\n        }\n\n        &__input {\n            min-height: 50px;\n            background: #FFFFFF;\n            border: 1px solid rgba(21, 36, 30, 0.08);\n            border-radius: 16px;\n            padding: 0 16px;\n            display: flex;\n            align-items: center;\n            font-size: 14px;\n            color: $text-main;\n            font-weight: 600;\n        }\n\n        // Sobrescribir MUI\n        :global(.MuiInputBase-root) {\n            min-height: 50px !important;\n            background: #fff !important;\n            border-radius: 16px !important;\n\n            .MuiOutlinedInput-notchedOutline {\n                border-color: rgba(21, 36, 30, 0.08) !important;\n            }\n        }\n    }\n\n    .side-photo {\n        display: grid;\n        gap: 16px;\n\n        @media (max-width: 1180px) {\n            justify-items: center;\n            text-align: center;\n            margin-bottom: 16px;\n        }\n\n        &__frame {\n            width: 176px;\n            height: 176px;\n            border-radius: 30px;\n            padding: 6px;\n            background: #FFFFFF;\n            box-shadow: 0 8px 20px rgba(18, 34, 28, 0.06);\n            position: relative;\n        }\n\n        &__img-container {\n            width: 100%;\n            height: 100%;\n            border-radius: 24px;\n            overflow: hidden;\n            background: #F1EEE8;\n\n            img {\n                width: 100%;\n                height: 100%;\n                object-fit: cover;\n            }\n        }\n\n        &__edit-btn {\n            position: absolute;\n            right: -2px;\n            bottom: -2px;\n            width: 34px;\n            height: 34px;\n            border-radius: 12px;\n            background: $color-primary;\n            color: #fff;\n            border: none;\n            display: grid;\n            place-items: center;\n            box-shadow: 0 6px 14px rgba(18, 34, 28, 0.12);\n            cursor: pointer;\n            font-weight: 800;\n        }\n\n        &__meta {\n            h3 {\n                margin: 0 0 6px;\n                font-size: 17px;\n                font-weight: 800;\n            }\n\n            p {\n                margin: 0;\n                font-size: 12px;\n                color: $text-secondary;\n                line-height: 1.55;\n            }\n        }\n    }\n\n    .save-bar {\n        position: sticky;\n        bottom: 20px;\n        z-index: 1000;\n        width: 100%;\n\n        &__pill {\n            min-height: 74px;\n            border-radius: 24px;\n            background: #F7F5F1;\n            border: 1px solid rgba(16, 25, 21, 0.05);\n            box-shadow: 0 10px 18px rgba(18, 34, 28, 0.10);\n            display: flex;\n            align-items: center;\n            justify-content: space-between;\n            padding: 12px 16px;\n            margin-top: 20px;\n\n            @media (max-width: 820px) {\n                flex-direction: column;\n                gap: 12px;\n                height: auto;\n                width: 100%;\n            }\n        }\n\n        &__state {\n            display: flex;\n            align-items: flex-start;\n            gap: 10px;\n        }\n\n        &__dot {\n            width: 10px;\n            height: 10px;\n            border-radius: 50%;\n            background: $color-primary;\n            margin-top: 6px;\n\n            &--saved {\n                background-color: #76A886;\n            }\n        }\n\n        &__copy {\n            font-size: 13px;\n            font-weight: 800;\n            color: $text-main;\n        }\n\n        &__sub {\n            font-size: 12px;\n            color: $text-secondary;\n        }\n\n        &__actions {\n            display: flex;\n            gap: 10px;\n\n            @media (max-width: 820px) {\n                width: 100%;\n            }\n        }\n    }\n\n    .save-cta {\n        min-width: 148px;\n        min-height: 42px;\n        border-radius: 14px;\n        background: $color-primary;\n        color: #fff;\n        border: none;\n        font-weight: 800;\n        cursor: pointer;\n        align-items: center;\n        justify-content: center;\n        font-size: 13px;\n        font-weight: 800;\n        white-space: nowrap;\n\n        @media (max-width: 820px) {\n            flex: 1;\n        }\n    }\n\n    .btn-secondary {\n        min-height: 40px;\n        padding: 0 18px;\n        border-radius: 14px;\n        background: transparent;\n        border: 1px solid rgba(130, 177, 148, 0.4);\n        color: $text-main;\n        font-weight: 800;\n        cursor: pointer;\n        align-items: center;\n        justify-content: center;\n        font-size: 13px;\n        font-weight: 800;\n        white-space: nowrap;\n\n        @media (max-width: 820px) {\n            flex: 1;\n        }\n    }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"patient-profile": `EditPatientPage_patient-profile__Ude0e`,
	"patient-profile__title-block": `EditPatientPage_patient-profile__title-block__2KQQE`,
	"patient-profile__hero-mark": `EditPatientPage_patient-profile__hero-mark__GUluk`,
	"patient-profile__main-title": `EditPatientPage_patient-profile__main-title__FdjpB`,
	"patient-profile__edit-trigger": `EditPatientPage_patient-profile__edit-trigger__V5Zs3`,
	"patient-profile__layout": `EditPatientPage_patient-profile__layout__Yzu+h`,
	"patient-profile__content-column": `EditPatientPage_patient-profile__content-column__5KrNt`,
	"patient-profile__card-stack": `EditPatientPage_patient-profile__card-stack__yLhqO`,
	"patient-profile__aside": `EditPatientPage_patient-profile__aside__D3Hm1`,
	"patient-profile__actions": `EditPatientPage_patient-profile__actions__vD-iy`,
	"content-card": `EditPatientPage_content-card__YPMxc`,
	"content-card__head": `EditPatientPage_content-card__head__4nXBC`,
	"content-card__name": `EditPatientPage_content-card__name__EzegJ`,
	"content-card__email": `EditPatientPage_content-card__email__Z6PXR`,
	"content-card__divider": `EditPatientPage_content-card__divider__0IPxF`,
	"content-card__grid-2": `EditPatientPage_content-card__grid-2__ehee4`,
	"content-card__grid-address": `EditPatientPage_content-card__grid-address__TJSQ8`,
	"content-card__grid-1": `EditPatientPage_content-card__grid-1__IU7Qa`,
	"content-card__section-title": `EditPatientPage_content-card__section-title__cDARv`,
	"content-card__view-text": `EditPatientPage_content-card__view-text__IKLNG`,
	"field": `EditPatientPage_field__4h8No`,
	"field__label": `EditPatientPage_field__label__XVLz3`,
	"field__input": `EditPatientPage_field__input__gQZkK`,
	"MuiOutlinedInput-notchedOutline": `EditPatientPage_MuiOutlinedInput-notchedOutline__no1lo`,
	"side-photo": `EditPatientPage_side-photo__UcIox`,
	"side-photo__frame": `EditPatientPage_side-photo__frame__4I7Ag`,
	"side-photo__img-container": `EditPatientPage_side-photo__img-container__15yjS`,
	"side-photo__edit-btn": `EditPatientPage_side-photo__edit-btn__w0R8X`,
	"side-photo__meta": `EditPatientPage_side-photo__meta__a6AEJ`,
	"save-bar": `EditPatientPage_save-bar__GWv4M`,
	"save-bar__pill": `EditPatientPage_save-bar__pill__ADoCs`,
	"save-bar__state": `EditPatientPage_save-bar__state__aLJlg`,
	"save-bar__dot": `EditPatientPage_save-bar__dot__vfhP-`,
	"save-bar__dot--saved": `EditPatientPage_save-bar__dot--saved__Ybnuu`,
	"save-bar__copy": `EditPatientPage_save-bar__copy__np5mk`,
	"save-bar__sub": `EditPatientPage_save-bar__sub__bLJMO`,
	"save-bar__actions": `EditPatientPage_save-bar__actions__6muDw`,
	"save-cta": `EditPatientPage_save-cta__U4skG`,
	"btn-secondary": `EditPatientPage_btn-secondary__V7nYN`
};
export default ___CSS_LOADER_EXPORT___;
